import { useFetchClient } from "~/composables/useFetchClient"

export const useDatoHelper = (errorRedirect = "/") => {
  const baseUrl = useRuntimeConfig().public.goliathUrl
  const client = useFetchClient('', 'Goliath API - Dato endpoint')
  const datoCmsDraftMode = useRuntimeConfig().public.datoCmsDraftMode
  const goliathApiToken = useRuntimeConfig().public.goliathApiToken

  const request = async (query, field) => {
    const data = {
      query,
      field
    }
    if (datoCmsDraftMode) {
      data.draft = true
    } else {
      data.draft = false
    }
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + goliathApiToken
    }
    const response = await client.post(baseUrl + '/dato/get', data, headers)
    if(response?.status){
      if(response?.status !== 200 ){
        navigateTo(errorRedirect);
      } else{
        return response?.data
      }
    } else{
      return response?.data
    }
  }

  const getRecordsList = async (model) => {

    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + goliathApiToken
    }
    const url = baseUrl + `/dato/get/records?model=${model}`
    const response = await client.get(url, headers)
    if(response?.status){
      if(response?.status !== 200 ){
        navigateTo(errorRedirect);
      } else{
        return response?.data
      }
    } else{
      return response?.data
    }
  }

  return {
    request,
    getRecordsList
  }
}
